<mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav
        #drawer
        class="sidenav"
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="(isHandset$ | async) === false"
    >
        <app-left-side-menu />
    </mat-sidenav>

    <mat-sidenav-content>
        @if (isHandset$ | async) {
            <mat-toolbar>
                <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
                    <mat-icon class="size-auto toggle-icon" aria-label="Side nav toggle icon"
                        ><i class="far fa-bars"></i
                    ></mat-icon>
                </button>
            </mat-toolbar>
        }
        <div class="content">
            <router-outlet />
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
